export const blockType = "ai-generated-block";
